// The site address is a single string (decision 13, 19 Aug 2026); the structured address fields
// were replaced. Only the site name and the address are ever required — no sub code, division,
// phone or point of contact blocks a save (S3.8). Total Number Of Employees stays on this CRM
// editor but is not captured in the wizard (decision 14), so it is optional here too.
export const fields = {
  companySiteID: {
    label: "companySiteID",
    type: "text",
  },
  // Length caps are Imperans' (bug 6495): the import writes these into ClientOffice, whose name is
  // 200 characters and whose DivSub is 10, so a longer value is refused here rather than at import.
  officeName: {
    label: "Office/Site Name",
    type: "text",
    rules: "required|string|max:200",
  },
  subCode: {
    label: "Sub Code / Project Code",
    type: "text",
    // Uppercased as typed (S3.1).
    observers: [
      {
        key: "value",
        call: ({ field }) => {
          const upper = (field.value || "").toUpperCase();
          if (upper !== field.value) field.set("value", upper);
        },
      },
    ],
  },
  division: {
    label: "Division",
    type: "text",
    rules: "string|max:10",
  },
  officeFullAddress: {
    label: "Address",
    type: "text",
    rules: "required|string",
  },
  // The parts of a Google-picked address, kept beside the single string so Imperans can write its
  // two Address rows without splitting it (story 6356, bug 6494). Never rendered or validated: the
  // address field fills them on a pick and empties them when the text is edited afterwards, and
  // they ride along in `values()` on save, blank (sent as null) for a typed address.
  streetAddress: {
    label: "Address line 1",
    type: "text",
  },
  suburb: {
    label: "Suburb",
    type: "text",
  },
  city: {
    label: "Town/City",
    type: "text",
  },
  state: {
    label: "State",
    type: "text",
  },
  postCode: {
    label: "Post code",
    type: "text",
  },
  sitePhone: {
    label: "Site Phone",
    type: "text",
  },
  franchiseID: {
    label: "TDDA Region",
  },
  isPrimaryOffice: {
    label: "Is Primary Office",
    value: false,
  },
};
